import React, { useState } from "react";

import _ from "lodash";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Chip from "@material-ui/core/Chip";
import Badge from "@material-ui/core/Badge";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";

import AddIcon from "@material-ui/icons/Add";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";

import TextField from "@material-ui/core/TextField";
import Slider from "@material-ui/lab/Slider";
import Tooltip from "@material-ui/core/Tooltip";

import stickertool01 from "../assets/img/tool-01.png";
import stickertool02 from "../assets/img/tool-02.png";
import stickertool03 from "../assets/img/tool-03.png";

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import { useStateAndLocalStorage } from "persistence-hooks";

//import PDF, { Text, AddPage, Line, Image, Table, Html } from "jspdf-react";
import jsPDF from "jspdf";

import icons from "../data/icons";

const theme = createMuiTheme({
  palette: {
    primary: {
      //light: '#33ab9f',
      main: "#EF7B30",
      //dark: '#00695f',
      contrastText: "#fff"
    },
    secondary: {
      //light: '#ff7961',
      main: "#F3AD3D",
      //dark: '#ba000d',
      contrastText: "#000"
    }
  }
});

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  textField: {},
  marginTop: {
    marginTop: 30
  },
  sliderRoot: {

  },
  sliderContainer: {
    overflow: "hidden",
    padding: "25px 30px",
    
  },
  sliderTrack: {

  },
  centered: {
    alignSelf: "center"
  },
  alignCentered: {
    textAlign: "center"
  },
  margin: {
    margin: theme.spacing(1)
  },
  marginRight: {
    marginRight: theme.spacing(2)
  },
  padding: {
    padding: `0 ${theme.spacing(2)}px`
  },
  paddingY: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4)
  },
  boxTitle: {
    marginBottom: theme.spacing(3)
  },
  stickertoolTeaser: {
    maxWidth: 50,
    //float: "left",
    marginLeft: "auto",
    marginRight: "auto",
    display: "block",
    [theme.breakpoints.up("sm")]: {
      //float: "none",
      maxWidth: 100
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: 150
    }
  },
  bordered: {
    borderWidth: 1,
    borderRadius: 10,
    borderStyle: "solid",
    borderColor: theme.palette.primary.main,
    padding: 20,
    margin: 20
  },
  teaser: {
    maxWidth: 250,
    marginLeft: "auto",
    marginRight: "auto",
    display: "block",
    [theme.breakpoints.up("md")]: {
      width: "50%",
      maxWidth: 500
    }
  },
  chip: {
    paddingRight: 5
  },
  chipImage: {
    width: 25
  },
  buyLink: {
    textDecoration: "none",
  },
  buyLinkText: {
    marginTop: 20,
    display: "inline-block",
    color: theme.palette.primary.main,
    fontWeight: 800,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    }
  },
  iframe: {
    border: "none"
  },
  dialogPaper: {
    margin: 10
  },
  dialogIconBtn: {
    display: "block",
    padding: 4,
    marginRight: 10,
    marginBottom: 10,
    float: "left",
    backgroundColor: "white",
    borderWidth: 2,
    borderColor: "white",
    borderStyle: "solid",
    "&:hover": {
      backgroundColor: "white",
      borderColor: theme.palette.primary.main
    }
  },
  dialogIconBtnActive: {
    borderColor: theme.palette.primary.main
    //backgroundColor: "black",
  },
  dialogIconBtnInActive: {
    cursor: "default",
    backgroundColor: "#9e9e9e",
    "&:hover": {
      backgroundColor: "#9e9e9e",
      borderColor: "white"
    }
  },
  dialogIconImage: {
    width: 40
  },
  dialogIconText: {
    fontSize: 11
  },
  floor: {
    borderWidth: 1,
    borderRadius: 5,
    borderStyle: "solid",
    borderColor: theme.palette.primary.main,
    padding: 0,
    marginBottom: 20
  },
  floorTitle: {
    fontSize: 16
  }
}));

// function sortProperties(obj, sortedBy, isNumericSort, reverse) {
//   sortedBy = sortedBy || 1; // by default first key
//   isNumericSort = isNumericSort || false; // by default text sort
//   reverse = reverse || false; // by default no reverse

//   var reversed = reverse ? -1 : 1;

//   var sortable = [];
//   for (var key in obj) {
//     if (obj.hasOwnProperty(key)) {
//       sortable.push([key, obj[key]]);
//     }
//   }
//   if (isNumericSort)
//     sortable.sort(function(a, b) {
//       return reversed * (a[1][sortedBy] - b[1][sortedBy]);
//     });
//   else
//     sortable.sort(function(a, b) {
//       var x = a[1][sortedBy].toLowerCase(),
//         y = b[1][sortedBy].toLowerCase();
//       return x < y ? reversed * -1 : x > y ? reversed : 0;
//     });
//   return sortable; // array in format [ [ key1, val1 ], [ key2, val2 ], ... ]
// }

const CartonSticker = () => {
  const classes = useStyles();
  const STORAGE_KEY = "CartonSticker";

  const DIALOG_DEFAULT = {
    open: false,
    title: "",
    icon: "",
    floor: 0,
    cartons: 1
  };

  const renderSticker = () => {
    let stickersByFloor = _.groupBy(stickers, function(sticker) {
      return sticker.floor;
    });

    let floors = [];
    Object.keys(stickersByFloor).map(function(k) {
      floors.push(parseInt(k));
      return true;
    });
    floors.sort(function(a, b) {
      return b - a;
    });
    return floors.map(floor => {
      return (
        <Grid container spacing={2} key={floor} className={classes.floor}>
          <Grid item xs={12}>
            <Typography
              variant="h5"
              color="textSecondary"
              className={classes.floorTitle}
            >
              {floor === 0
                ? "Erdgeschoss"
                : floor === -1
                ? "Keller"
                : `Etage ${floor}`}
            </Typography>
            {renderFloor(stickersByFloor[floor])}
          </Grid>
        </Grid>
      );
    });
  };

  const renderFloor = items => {
    return Object.keys(items).map(area => {
      //console.log("renderFloor", items);
      return (
        <Badge
          className={classes.margin}
          badgeContent={items[area].cartons}
          color="primary"
          key={area}
        >
          <Chip
            className={classes.chip}
            label={items[area].title}
            color="primary"
            onClick={e => handleEdit(e, items[area])}
            icon={
              <img
                className={classes.chipImage}
                src={`${
                  icons[items[area].icon] ? icons[items[area].icon].png : ""
                }`}
                alt=""
              />
            }
            variant="outlined"
          />
        </Badge>
      );
    });
  };

  const handleEdit = (e, item) => {
    // console.log("handleEdit", item);
    setDialog({
      open: true,
      id: parseInt(item.id),
      title: item.title,
      cartons: item.cartons,
      icon: item.icon,
      floor: item.floor
    });
  };

  const [dialog, setDialog] = useState(DIALOG_DEFAULT);

  React.useEffect(() => {
    // console.log("dialog change ", dialog);
  }, [dialog]);

  const handleDialogClose = e => {
    setDialog(DIALOG_DEFAULT);
  };

  const handleDialogDelete = e => {
    stickers.forEach(function(elm, idx) {
      if (elm.id === dialog.id) {
        stickers.splice(idx, 1);
      }
    });
    setStickers(stickers);
    setDialog(DIALOG_DEFAULT);
  };

  const handleDialogSave = e => {
    if (!dialog.title) {
      alert("Bitte Titel angeben");
    } else if (dialog.carton === 0) {
      alert("Bitte eine Kartonanzahl angeben");
    } else if (!dialog.icon) {
      alert("Bitte ein Icon angeben");
    } else if (dialog.floor < -1 || dialog.floor > 3) {
      alert("Bitte eine Etage zwischen -1 und 3 angeben");
    } else {
      stickers.forEach(function(elm, idx) {
        if (elm.id === dialog.id) {
          stickers[idx] = {
            id: elm.id,
            title: dialog.title,
            icon: dialog.icon,
            floor: dialog.floor,
            cartons: dialog.cartons
          };
        }
      });
      setStickers(stickers);
      setDialog(DIALOG_DEFAULT);
    }
  };

  const handleDialogNew = e => {
    if (!dialog.title) {
      alert("Bitte Titel angeben");
    } else if (dialog.carton === 0) {
      alert("Bitte eine Kartonanzahl angeben");
    } else if (!dialog.icon) {
      alert("Bitte ein Icon angeben");
    } else if (dialog.floor < -1 || dialog.floor > 3) {
      alert("Bitte eine Etage zwischen -1 und 3 angeben");
    } else {
      stickers.push({
        id: Math.floor(Date.now() / 1000),
        title: dialog.title,
        icon: dialog.icon,
        floor: dialog.floor,
        cartons: dialog.cartons
      });
      setStickers(stickers);
      setDialog(DIALOG_DEFAULT);
    }
  };

  const handleInputChange = e => {
    const { id, value } = e.target;
    setDialog({ ...dialog, [id]: value });
  };

  const handeDialogIconChange = name => e => {
    setDialog({ ...dialog, icon: name });
  };

  const handleSliderChange = name => (e, value) => {
    //setValues({ ...values, [name]: parseInt(value) });
    //console.log("slider", name, " - ", parseInt(value));
    setDialog({ ...dialog, [name]: parseInt(value) });
  };

  const openNewDialog = e => {
    setDialog({ ...dialog, open: true });
  };

  function floorToText(floor) {
    return floor === 0
      ? "Erdgeschoss"
      : floor === -1
      ? "Keller"
      : floor + ". Etage";
  }

  const print = type => {
    var doc = new jsPDF({});

    let height = 45,
      count = 0,
      page = 1,
      iconPosX = 0,
      imgHeight = 0,
      imgStairsUp =
        "data:image/png;base64,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",
      imgStairsDown =
        "data:image/png;base64,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",
      logo =
        "data:image/png;base64,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";

    doc.setDrawColor(200, 200, 200);
    doc.setTextColor(150, 150, 150);
    // print stickers room

    let stickersByFloor = _.groupBy(stickers, function(sticker) {
      return sticker.floor;
    });

    let roomStickersArray = [];
    if (type === "all" || type === "orientation") {
      Object.keys(stickersByFloor).map(function(k) {
        // floor

        // FLOOR STICKERS
        if (parseInt(k) !== 0) {
          let floorCount = 0;
          if (parseInt(k) > 0) {
            floorCount = k;
          } else {
            floorCount = k * -1;
          }
          for (var i = 0; i < floorCount; i++) {
            // eslint-disable-next-line
            stickersByFloor[k].forEach(function(elm, idx) {
              // console.log("roomStickers #1");
              roomStickersArray.push({
                icon: elm.icon,
                //title: `Treppe ${floorToText(i)} für ${elm.title} (${floorToText(
                //  elm.floor
                //)})`
                title: `Treppe | ${floorToText(i)}`
              });
            });
          }
        }
        return true;
      });
      Object.keys(stickersByFloor).map(function(k) {
        stickersByFloor[k].forEach(function(elm, idx) {
          // console.log("roomStickers #2");
          roomStickersArray.push({
            icon: elm.icon,
            title: `Tür | ${elm.title} (${floorToText(elm.floor)})`
          });
          roomStickersArray.push({
            icon: elm.icon,
            title: `Ablageort der Kartons | ${elm.title} (${floorToText(
              elm.floor
            )})`
          });
        });
        return true;
      });

      // console.log("roomStickersArray", roomStickersArray);

      doc.setFontSize(8);
      iconPosX = 4.67;

      roomStickersArray.forEach(function(sticker, idx) {
        // console.log("roomStickers #3 - ", idx);
        if (idx !== 0 && idx % 6 === 0) {
          page++;
          iconPosX = 4.67;
          doc.addPage();
        }
        if (idx === 0 || idx % 6 === 0) {
          //doc.text("Umzugskram Aufkleber", 105, 5, { align: "center" });
          height = 8.805;
        }

        if (idx % 2 !== 0) {
          iconPosX = 99.06 + 2.54;
        }

        doc.rect(iconPosX, height, 99.06, 93.13);
        doc.setFontSize(8);
        doc.text(
          "Klebe mich bitte an folgenden Ort:",
          iconPosX + 50,
          height + 85,
          {
            align: "center"
          }
        );
        doc.setFontSize(10);
        doc.text(sticker.title, iconPosX + 50, height + 90, {
          align: "center"
        });

        doc.addImage(logo, "PNG", iconPosX + 31, height + 1, 36, 6);

        doc.addImage(
          icons[sticker.icon].png,
          "PNG",
          iconPosX + 10,
          height + 5,
          75,
          75
        );

        if (idx % 2 !== 0) {
          iconPosX = 4.67;
          height += 93.13;
        }
      });
    }

    if (type === "all" || type === "carton") {
      doc.setFontSize(12);
      doc.text("Seite " + page, 105, 280, { align: "center" });
      page++;
      if (type === "all") doc.addPage();
      count = 0;
      height = 0;

      // print stickers cartons
      stickers.forEach(function(elm, idx) {
        //console.log("elm.cartons,", elm.cartons);
        if (elm.cartons === 0) {
          console.warn(elm.id, " with 0 cartons...");
          return true;
        }
        //return true;
        for (var i = 0; i < elm.cartons; i++) {
          //console.log("roomStickers #4", elm.id, i);
          if (count % 5 === 0 && count !== 0) {
            doc.setFontSize(12);
            doc.text("Seite " + page, 105, 290, { align: "center" });
            //console.log("END PAGE ", page);
            page++;
            doc.addPage();
          }

          if (count === 0 || count % 5 === 0) {
            doc.setFontSize(16);
            //doc.text("Umzugskram Aufkleber", 105, 10, { align: "center" });
            doc.setFontSize(12);
            doc.text("Jeweils 3 Aufkleber pro Karton nutzbar", 105, 15, {
              align: "center"
            });
            height = 21.5;
          }

          iconPosX = 0;
          doc.setFontSize(8);
          // ------------------------

          doc.rect(iconPosX, height, 70, 50.8);

          doc.addImage(logo, "PNG", iconPosX + 20, height + 1, 30, 5);
          // doc.text(
          //   elm.title + " | " + (i + 1) + "/" + elm.cartons,
          //   iconPosX + 35,
          //   height + 47,
          //   {
          //     align: "center"
          //   }
          // );

          if (parseInt(elm.floor) !== 0) {
            if (parseInt(elm.floor) > 0) {
              imgHeight = height + 2;
              for (var j = 0; j < elm.floor; j++) {
                //console.log("floor up ", i);
                doc.addImage(imgStairsUp, "PNG", iconPosX + 5, imgHeight, 8, 8);
                imgHeight += 12;
              }
            } else {
              imgHeight = height + 40;
              let floorNeg = elm.floor * -1;
              //console.log("floorNeg", floorNeg);
              for (var k = 0; k < floorNeg; k++) {
                //console.log("floor down ", j);
                doc.addImage(
                  imgStairsDown,
                  "PNG",
                  iconPosX + 5,
                  imgHeight,
                  8,
                  8
                );
                imgHeight -= 12;
              }
            }
          }
          doc.addImage(
            icons[elm.icon].png,
            "PNG",
            iconPosX + 15,
            height + 10,
            40,
            40
          );

          // ------------------------
          iconPosX += 70;
          // ------------------------
          doc.rect(iconPosX, height, 70, 50.8);
          doc.addImage(logo, "PNG", iconPosX + 20, height + 1, 30, 5);
          // doc.text("umzugskram.de", iconPosX + 35, height + 4, {
          //   align: "center"
          // });
          // doc.text(
          //   elm.title + " | " + (i + 1) + "/" + elm.cartons,
          //   iconPosX + 35,
          //   height + 47,
          //   {
          //     align: "center"
          //   }
          // );
          if (parseInt(elm.floor) !== 0) {
            if (parseInt(elm.floor) > 0) {
              imgHeight = height + 2;
              for (var l = 0; l < elm.floor; l++) {
                doc.addImage(imgStairsUp, "PNG", iconPosX + 5, imgHeight, 8, 8);
                imgHeight += 12;
              }
            } else {
              imgHeight = height + 40;
              let floorNeg = elm.floor * -1;
              for (var m = 0; m < floorNeg; m++) {
                doc.addImage(
                  imgStairsDown,
                  "PNG",
                  iconPosX + 5,
                  imgHeight,
                  8,
                  8
                );
                imgHeight -= 12;
              }
            }
          }
          doc.addImage(
            icons[elm.icon].png,
            "PNG",
            iconPosX + 15,
            height + 10,
            40,
            40
          );
          // ------------------------
          iconPosX += 70;
          // ------------------------
          doc.rect(iconPosX, height, 70, 50.8);
          // doc.text("umzugskram.de", iconPosX + 35, height + 4, {
          //   align: "center"
          // });
          doc.addImage(logo, "PNG", iconPosX + 20, height + 1, 30, 5);
          // doc.text(
          //   elm.title + " | " + (i + 1) + "/" + elm.cartons,
          //   iconPosX + 35,
          //   height + 47,
          //   {
          //     align: "center"
          //   }
          // );
          if (parseInt(elm.floor) !== 0) {
            if (parseInt(elm.floor) > 0) {
              imgHeight = height + 2;
              for (var n = 0; n < elm.floor; n++) {
                doc.addImage(imgStairsUp, "PNG", iconPosX + 5, imgHeight, 8, 8);
                imgHeight += 12;
              }
            } else {
              imgHeight = height + 40;
              let floorNeg = elm.floor * -1;
              for (var o = 0; o < floorNeg; o++) {
                doc.addImage(
                  imgStairsDown,
                  "PNG",
                  iconPosX + 5,
                  imgHeight,
                  8,
                  8
                );
                imgHeight -= 12;
              }
            }
          }
          doc.addImage(
            icons[elm.icon].png,
            "PNG",
            iconPosX + 15,
            height + 10,
            40,
            40
          );
          // ------------------------
          // console.log("NEXT ROW");
          count++;

          height += 50.8;
        }
      });
    }

    doc.save("stickers.pdf");
  };

  const [stickers, setStickers] = useStateAndLocalStorage([], STORAGE_KEY);

  React.useEffect(() => {
    //("sticker changed...", stickers);
  }, [stickers]);

  return (
    <MuiThemeProvider theme={theme}>
      {/* <React.Fragment>
        <PDF properties={PDF_PROPERTIES} preview={true}>
          <Text x={35} y={25} size={40}>
            Octonyan loves jsPDF
          </Text>
          <Text x={35} y={125} size={40}>
            Octonyan loves jsPDF
          </Text>

          <Line x1={20} y1={20} x2={60} y2={20} />
        </PDF>
      </React.Fragment> */}

      <Grid container className={classes.paddingY}>
        <Grid item xs={12} md={12} className={classes.centered}>
          <Typography
            component="h2"
            variant="h4"
            align="center"
            color="textPrimary"
            className={classes.boxTitle}
          >
            Die Umzugskram Sticker
          </Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <img
                src={stickertool01}
                alt=""
                className={classes.stickertoolTeaser}
              />
              <Typography
                variant="body1"
                align="center"
                color="textPrimary"
                paragraph
              >
                Sticker mit dem Konfigurator erstellen und auf Klebe-Etiketen
                drucken (Alternative: Auf Papier drucken und ausschneiden)
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <img
                src={stickertool02}
                alt=""
                className={classes.stickertoolTeaser}
              />
              <Typography
                variant="body1"
                align="center"
                color="textPrimary"
                paragraph
              >
                Sticker auf die Kartons und Wegweiser-Sticker über die Türen,
                Treppen und Ablageort kleben.
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <img
                src={stickertool03}
                alt=""
                className={classes.stickertoolTeaser}
              />
              <Typography
                variant="body1"
                align="center"
                color="textPrimary"
                paragraph
              >
                Leichte Orientierung am Umzugstag beim Tragen der Kartons. Schau
                auf den Sticker auf dem Karton und folge den Wegweiser-Sticker
                bis zum Ablageort.
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Divider variant="middle" className={classes.marginTop} />
          <Typography
          component="h3"
            variant="h5"
            align="center"
            color="textPrimary"
            className={classes.marginTop}
          >
            Konfiguriere deine Sticker
          </Typography>
          <Typography variant="body2" color="textPrimary" align="center">
            Lege einfach neue Ablageorte mit einem passenden Symbol und der
            Anzahl deiner Kartons an. Anschließend kannst du dir die Etiketten
            fertig zum Drucken herunterladen.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <div className={classes.marginTop}>{renderSticker()}</div>
          <div className={classes.marginTop}>
          {stickers.length === 0 && (
            <Button
              onClick={openNewDialog}
              variant="contained"
              color="primary"
              className={classes.marginRight}
            >
              <AddIcon className={classes.marginRight} /> Erstelle deinen ersten Ablageort
            </Button>
          )}
          {stickers.length > 0 && (
            <Button
              onClick={openNewDialog}
              variant="contained"
              color="primary"
              className={classes.marginRight}
            >
              <AddIcon className={classes.marginRight} /> Ablageort
            </Button>
          )}
            {/* {stickers.length > 0 && (
              <Button onClick={() => print("all")} variant="contained" color="primary">
                <SaveIcon className={classes.marginRight} />
                Sticker
              </Button>
            )} */}
          </div>
        </Grid>
        {stickers.length > 0 && (
          <Grid item xs={12} md={12} className={classes.marginTop}>
            <Divider variant="middle" />
            <Grid container spacing={2} className={classes.marginTop}>
              <Grid item xs={12}>
                <Typography variant="h5" align="center" color="textPrimary">
                  Sticker laden
                </Typography>
                <Typography variant="body2" color="textPrimary" align="center">
                  Bitte beachte beim Drucken, das du die Seiten mit den
                  korrekten Klebeetiketten bedruckst. Du findest beide Vorlage
                  als Link* zum Kauf.
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} className={classes.alignCentered}>
                {stickers.length > 0 && (
                  <Button
                    onClick={() => print("orientation")}
                    variant="contained"
                    color="primary"
                  >
                    <SaveIcon className={classes.marginRight} />
                    Wegweiser Sticker
                  </Button>
                )}
                <div className={classes.bordered}>
                  <a
                    href="https://www.amazon.de/Herma-8332-Versandetiketten-wetterfest-selbstklebend/dp/B004UTZ2TQ/ref=as_li_ss_il?__mk_de_DE=%C3%85M%C3%85%C5%BD%C3%95%C3%91&keywords=adressaufkleber+150&qid=1558006221&s=gateway&sr=8-3&linkCode=li2&tag=umzugskram-21&linkId=8655eb67cbd829784de54a878d5acb00&language=de_DE"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.buyLink}
                  >
                    <img
                      className={classes.stickertoolTeaser}
                      border="0"
                      alt="sticker"
                      src="//ws-eu.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B004UTZ2TQ&Format=_SL160_&ID=AsinImage&MarketPlace=DE&ServiceVersion=20070822&WS=1&tag=umzugskram-21&language=de_DE"
                    />
                    <img
                      src="https://ir-de.amazon-adsystem.com/e/ir?t=umzugskram-21&language=de_DE&l=li2&o=3&a=B004UTZ2TQ"
                      width="1"
                      height="1"
                      border="0"
                      alt=""
                    />
           
                    <span
                      className={classes.buyLinkText}

                    >
                      Aufkleber-Papier für die Karton-Sticker*
                    </span>
                  </a>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} className={classes.alignCentered}>
                {stickers.length > 0 && (
                  <Button
                    onClick={() => print("carton")}
                    variant="contained"
                    color="primary"
                  >
                    <SaveIcon className={classes.marginRight} />
                    Karton Sticker
                  </Button>
                )}
                <div className={classes.bordered}>
                  <a
                    href="https://www.amazon.de/Herma-5055-Klebeetiketten-bedruckbar-selbstklebend/dp/B000KJRD4C/ref=as_li_ss_il?&linkCode=li2&tag=umzugskram-21&linkId=0de768f19ab906b1f28c77df352321b4&language=de_DE"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.buyLink}
                  >
                    <img
                      className={classes.stickertoolTeaser}
                      border="0"
                      alt="sticker"
                      src="//ws-eu.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B000KJRD4C&Format=_SL160_&ID=AsinImage&MarketPlace=DE&ServiceVersion=20070822&WS=1&tag=umzugskram-21&language=de_DE"
                    />
                    <img
                      src="https://ir-de.amazon-adsystem.com/e/ir?t=umzugskram-21&language=de_DE&l=li2&o=3&a=B000KJRD4C"
                      width="1"
                      height="1"
                      border="0"
                      alt=""
                    />
                    <span
                      className={classes.buyLinkText}

                    >
                      Aufkleber-Papier für die Wegweiser-Sticker*
                    </span>
                  </a>
                </div>
              </Grid>
              <Grid item xs={12} className={classes.centered}>
                <Typography
                  variant="caption"
                  align="center"
                  color="textPrimary"
                >
                  * Affiliate-Links (d.h. der Kaufpreis ändert sich nicht und
                  umzugskram.de erhält bei Kauf über den Link eine Provision)
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>

      <Dialog
        classes={{ paper: classes.dialogPaper }}
        open={dialog.open}
        onClose={handleDialogClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Ablageort</DialogTitle>
        <DialogContent>
          {/* <DialogContentText>
            To subscribe to this website,w please enter your email address here.
            We will send updates occasionally.
          </DialogContentText> */}
          <Grid item xs={12}>
            <Typography component="h5" color="textPrimary">
              Name vom Ablageort (z.B. "Schlafzimmer")
            </Typography>
          </Grid>
          <TextField
            autoFocus
            margin="dense"
            id="title"
            //label="Name vom Ablageort"
            variant="outlined"
            ƒ
            type="text"
            value={dialog.title || ""}
            fullWidth
            onChange={handleInputChange}
          />
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography component="h5" color="textPrimary">
                Das Icon auf dem Karton und für den Ablageort
              </Typography>
            </Grid>
            <Grid item xs={12}>
              {Object.keys(icons).map((icon, i) => {
                let active = true;
                if (stickers.length > 0) {
                  stickers.forEach(function(elm, idx) {
                    if (
                      elm.icon === icon &&
                      dialog.icon !== elm.icon &&
                      dialog.id !== elm.id
                    ) {
                      active = false;
                    }
                  });
                }

                return (
                  <Tooltip
                    key={i}
                    title={!active ? "Bereits verwendet" : "Noch frei"}
                  >
                    <Button
                      color="primary"
                      onClick={active ? handeDialogIconChange(icon) : null}
                      variant="contained"
                      className={`${classes.dialogIconBtn} ${
                        dialog.icon === icon ? classes.dialogIconBtnActive : ""
                      } ${!active ? classes.dialogIconBtnInActive : ""}`}
                    >
                      <img
                        className={`${classes.dialogIconImage} `}
                        src={`${icons[icon].png}`}
                        alt=""
                      />
                      {/* <div className={classes.dialogIconText}>{icons[icon].name}</div> */}
                    </Button>
                  </Tooltip>
                );
              })}
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography component="h5" color="textPrimary">
                Anzahl der Kartons (Es werden 3 Sticker pro Karton gedruckt)
              </Typography>
            </Grid>
            <Grid item xs={4} md={3}>
              <TextField
                id="cartons"
                className={classes.textField}
                onChange={handleInputChange}
                variant="outlined"
                //label="Kartons"
                type="integer"
                value={dialog.cartons || 1}
                inputProps={{ min: "1", max: "30", step: "1" }}
              />
            </Grid>
            <Grid item xs={8} md={9}>
              <Slider
                classes={{ root: classes.sliderRoot, container: classes.sliderContainer, track: classes.sliderTrack }}
                value={dialog.cartons || 1}
                min={1}
                max={30}
                step={1}
                onChange={handleSliderChange("cartons")}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography component="h5" color="textPrimary">
                Etage ( 0 = Erdgeschoss)
              </Typography>
            </Grid>
            <Grid item xs={4} md={3}>
              <TextField
                id="floor"
                className={classes.textField}
                onChange={handleInputChange}
                variant="outlined"
                //label="Etage"
                type="integer"
                value={dialog.floor || 0}
                inputProps={{ min: "-1", max: "2", step: "1" }}
              />
            </Grid>
            <Grid item xs={8} md={9}>
              <Slider
                classes={{ root: classes.sliderRoot, container: classes.sliderContainer, track: classes.sliderTrack }}
                value={dialog.floor || 0}
                min={-1}
                max={2}
                step={1}
                onChange={handleSliderChange("floor")}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Abbrechen
          </Button>
          {dialog.id ? (
            <div>
              <Button onClick={handleDialogDelete} color="primary">
                Löschen
              </Button>
              <Button onClick={handleDialogSave} color="primary">
                Speichern
              </Button>
            </div>
          ) : (
            <Button onClick={handleDialogNew} color="primary">
              Neu anlegen
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </MuiThemeProvider>
  );
};

export default CartonSticker;
